import { render, staticRenderFns } from "./ConfiguracoesVendaHeader.vue?vue&type=template&id=01004ec3"
import script from "./ConfiguracoesVendaHeader.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesVendaHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports